export default {
  rail: {
    opacity: 0.25,
    height: '2px',
  },
  thumb: {
    'margin-top': '-4px',
  },
  mark: {
    width: '2px',
    height: '2px',
    'border-radius': '2px',
  },
};
